interface Props {
  [key: string]: any
}

export default function VolumeOffIcon(props: Props): React.ReactElement {
  const { pathClassName, ...rest } = props
  return (
    <svg fill="none" viewBox="0 0 98 98" {...rest} xmlns="http://www.w3.org/2000/svg">
      <path
        className={pathClassName ? `stroke-current ${pathClassName}` : ''}
        d="M16.3333 61.2499H22.8095L42.0298 80.4701C44.6023 83.0426 49 81.2214 49 77.5832V20.4165C49 16.7783 44.6023 14.9571 42.0298 17.5296L22.8095 36.7499H16.3333C15.2504 36.7499 14.2118 37.1801 13.446 37.9458C12.6802 38.7116 12.25 39.7502 12.25 40.8332V57.1665C12.25 58.2495 12.6802 59.2881 13.446 60.0539C14.2118 60.8197 15.2504 61.2499 16.3333 61.2499Z"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="8.16667"
      />
      <path
        className={pathClassName ? `stroke-current ${pathClassName}` : ''}
        d="M77.5832 48.9997L85.7498 57.1663M69.4165 57.1663L77.5832 48.9997L69.4165 57.1663ZM77.5832 48.9997L85.7498 40.833L77.5832 48.9997ZM77.5832 48.9997L69.4165 40.833L77.5832 48.9997Z"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="8.16667"
      />
    </svg>
  )
}
